<form (ngSubmit)="onSubmit()" [formGroup]="form">
  <div class="row mb-4">
    <div class="col-12">
      <div>
        <autocomplete
          [clearable]="false"
          [url]="propertiesService.getAll.bind(propertiesService)"
          bindLabel="name"
          formControlName="buildingId"
          inputValidator
          label="BUILD_DASHBOARD.PROPERTY">
          <ng-template #label let-item="item" ng-label-tmp>
            {{ item.address }}
          </ng-template>
        </autocomplete>
      </div>
    </div>
    <div class="col-12">
      <div>
        <autocomplete
          [clearable]="false"
          [url]="utilityProvidersService.getAll.bind(utilityProvidersService)"
          formControlName="utilityProviderId"
          inputValidator
          label="MENU.UTILITY_PROVIDERS"
        />
      </div>
    </div>
    <div class="col-12">
      <div>
        <autocomplete
          [clearable]="false"
          [url]="utilityProviderTypesService.getAll.bind(utilityProviderTypesService)"
          [parentControl]="form.get('utilityProviderId')"
          formControlName="utilityProviderTypeId"
          inputValidator
          label="METER_TYPE.UTILITY_TYPE"
        >
        </autocomplete>
      </div>
    </div>
    <div class="col-12">
      <p-inputNumber
        [useGrouping]="false"
        mode="decimal"
        class="w-100"
        styleClass="w-100"
        inputStyleClass="form-control"
        formControlName="price"
        inputValidator
        [minFractionDigits]="0"
        [maxFractionDigits]="5"
        label="TARIFFS.PRICE"
      />
    </div>
    <div class="col-12">
      <div>
        <input
          class="form-control"
          formControlName="taxRate"
          inputValidator
          label="UTILITYRATES.TAXRATE">
      </div>
    </div>
  </div>

  <div class="text-end d-flex gap-2 justify-content-end">
    <p-button [disabled]="form.invalid || isPending()" styleClass="btn btn-primary d-flex" [loading]="isPending()" type="submit" [label]="'SAVE'|translate"></p-button>
    <button (click)="cancel()" class="btn btn-soft-primary" type="button">{{ 'CANCEL' | translate }}</button>
  </div>
</form>
